<template>
  <div class="tw-cursor-pointer evenement" @click="selectDate(event.acfEvent.dates[0])">
    <div class="tw-mb-12 tw-relative">
      <v-img :aspect-ratio="16/9" :src="event.acfEvent.imagePrincipale.sourceUrl" :lazy-src="event.acfEvent.imagePrincipale.sourceUrl"/>
    </div>

    <div class="text-1-2 tw-font-bold tw-uppercase tw-text-pink">
      {{ event.acfEvent.dates[0].dateDebut }} <span v-if="event.acfEvent.dates[0].dateFin"> au {{ event.acfEvent.dates[0].dateFin }} </span> | {{ event.acfEvent.dates[0].ville }}
    </div>
    <h3 class="text-1-8 tw-font-bold">{{ event.title }}</h3>
    <h4 class="text-1-8">{{ event.acfEvent.organisateurs }}</h4>
  </div>
</template>

<script>
import store from "../../store";
import router from "../../router";

export default {
  name: "Event",
  props : ['event'],
  methods: {
    selectDate(date) {
      store.commit('setCurrentEvent' , date)
      store.commit('setFixedEvent' , true)
      router.push('/evenement/'+this.event.slug)
    },
  }
}
</script>

<style lang="scss" scoped>

</style>